module.exports = __webpack_public_path__ + "img/pr-1.f01f4c98.png";